/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"808ktD":["Get recommendations on how to fix or improve your video player experience."],"7fRtyQ":["Test Video Player Access"],"+OopUl":["YouTube Access"],"ADG4xi":["Youtube.com check passed"],"p62/wL":["Youtube.com check failed"],"xGVfLh":["Continue"],"7L9GHo":["YouTube Video Player"],"fdaGKn":["Can you play this video? (1/2)"],"l75CjT":["Yes"],"1UzENP":["No"],"ctWMpV":["Backup Video Player"],"yrf1lF":["Can you play this video? (2/2)"],"jRJxEZ":["Ensure youtube.com is not blocked"],"KQuFpn":["Ensure youtube-nocookie.com is not blocked"],"Nlf1JU":["Ensure googlevideo.com is not blocked"],"9RUJUK":["Ensure kastatic.org is not blocked"],"xGmT2I":["Ensure that showing an iframe from another origin is not blocked"],"RgP3NT":["Cannot access youtube.com"],"QWa7B3":["Can access youtube.com"],"HS/11O":["Cannot use the YouTube player"],"YK5YD4":["Can use the YouTube player"],"c4nB3g":["Cannot use the backup player"],"On8as+":["Can use the backup player"],"IwEH6E":["To access additional video playback controls, follow these guidelines to unblock the YouTube player."],"zwWKhA":["Learn more"],"FXN0ro":["Recommendations"],"i9qgxw":["Playing Videos on Khan Academy"],"0DGrp8":["Browser"],"Awqlju":["We do not support your browser. We support the latest versions of Firefox, Chrome, Safari, and Edge"],"HQybjW":["We support the latest version of your browser"],"F/8ssM":["Site Cookies"],"rNiEmF":["First party cookie check passed"],"JW89BC":["First party cookie check failed"],"x7++4y":["Third party cookie check is pending"],"MqgrdJ":["Third party cookie check passed"],"Rc9GQ7":["Third party cookie check failed"],"2cRm5o":["Third party cookie check could not be completed because the iframe check failed"],"0NNrXQ":["Iframes"],"dQrNGI":["Iframe check pending"],"xBJGQ5":["Iframe check passed"],"yZs/4m":["Iframe check failed"],"M8bepv":["Khan Academy Access Check"],"KGjdZw":["This page detects some of the common network issues described in this article: "],"lfBPS6":["Which sites/domains do I safelist so my students can access all of Khan Academy?"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["ur","te","or","ko","km","bn","ta","rw","pt-pt","my","mn","kn","gu","fv","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
